/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { Menu } from '../menu/Menu';
import { Header, List, Container, Segment } from 'semantic-ui-react';
import { useDispatch } from 'react-redux';
import { setRoom, emptyAvailable, emptyKills, emptyCombat, setWinner, setPlayer } from '../../actions';

export default function Home() {
    const dispatch = useDispatch();
    useEffect(()=>{
        dispatch(emptyAvailable());
        dispatch(emptyKills());
        dispatch(emptyCombat());
        dispatch(setWinner(0));
        dispatch(setPlayer(0));
        dispatch(setRoom(-1));
    },[])
    return (
        <>
            <Container>
                <Menu />
                <Segment secondary inverted raised>
                    <Container fluid textAlign='left'>
                        <Header as='h2'>Játékszabály</Header>
                        <p>
                            Két játékos játszik egymással egy-egy hadsereg élén.
                            Cél az ellenfél zászlójának megszerzése. A tábla 6x6
                            cellából áll. Eredetileg mindkét félnek 12 bábuja
                            van: 1 zászló, 2 bomba, és katonák. Egymás bábuit
                            azonban nem látják, csak akkor, amikor két bábu
                            csatázni kezd. Ekkor az erősebb bábu marad a pályán,
                            a gyengébbik leesik a tábláról. Ha két azonos bábu
                            harcol egymással, akkor mindkettő lekerül a
                            tábláról. Minden bábu csak 1-et léphet előre, hátra,
                            jobbra, balra. A zászló és az akna értelemszerűen
                            nem tud lépni.
                        </p>
                        <p>Van pár speciális figura:</p>
                        <List bulleted>
                            <List.Item>
                                a 2-es a felderítő, ő akárhány mezőt átugorva
                                léphet vagy támadhat. Tavat ő sem tudja átugrani
                            </List.Item>
                            <List.Item>
                                a 3-as az aknász. Csak ő tudja hatástalanítani a
                                bombát
                            </List.Item>
                            <List.Item>
                                az 1-es a kém, ha ő támadja meg az ellenfél
                                10-esét, akkor megöli
                            </List.Item>
                            <List.Item>
                                bomba: aki rálép, az felrobban, a bomba viszont
                                megmarad. Csak az aknász képes leszedni a
                                tábláról
                            </List.Item>
                        </List>
                    </Container>
                </Segment>
            </Container>
        </>
    );
}
